export const SPORSMAL_ID = "sporsmalId";
export const NOTAT_ID = "notatId";

export const INNSENDINGSKODE = "innsendingsKode";
export const MANUELLREGISTRERINGSKODE = "manuellRegistreringsKode";
export const FORHANDSVISNINGSKODE = "forhandsVisningsKode";
